export const RWC_COMPONENTS_TYPES = {
    RWC_HEADER: "RWC_HEADER",
    RWC_WHY_CHOOSE_CARS24: "RWC_WHY_CHOOSE_CARS24",
    RWC_HOW_IT_WORKS: "RWC_HOW_IT_WORKS",
    RWC_WHY_NEED_RWC: "RWC_WHY_NEED_RWC",
    RWC_WHATS_INSPECTED: "RWC_WHATS_INSPECTED",
    RWC_BEST_VALUE_FOR_MONEY: "RWC_BEST_VALUE_FOR_MONEY",
    RWC_OUR_LOCATION: "RWC_OUR_LOCATION",
    AU_RATING_REVIEW: "AU_RATING_REVIEW",
    RWC_SERVICES: "RWC_SERVICES",
    RWC_SEO_QUESTIONS: "RWC_SEO_QUESTIONS",
    RWC_FAQS: "RWC_FAQS"
};

export const CB_TYPES = {
    OPEN_FORM_DETAILS_MODAL: "OPEN_FORM_DETAILS_MODAL",
    CLOSE_FORM_DETAILS_MODAL: "CLOSE_FORM_DETAILS_MODAL"
};
